export type UiTheme = 'DARK' | 'LIGHT' | 'SYSTEM'

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  BLOCKED = 'BLOCKED',
  DEPARTED = 'DEPARTED',
  REMOVED = 'REMOVED',
}

export enum UserType {
  USER = 'USER',
  CREATOR = 'CREATOR',
}

export enum CreatorType {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
}

export enum UserPaginateOrder {
  RECENT = 'RECENT',
  POPULAR = 'POPULAR',
  FOLLOWER = 'FOLLOWER',
}

export enum CreatorProfileRowType {
  TEXT = 'TEXT',
  DATE = 'DATE',
}

export enum SubType {
  NORMAL = 'NORMAL',
  EDITOR = 'EDITOR',
}
